export default function Projects() {
  const projects = [
    {
      title: 'Reforma Integral Vivienda',
      category: 'Residencial',
      image: 'https://public.readdy.ai/ai/img_res/0efb2efefc66c96a996af274a7c64c7e.jpg',
      description: 'Reforma completa incluyendo pintura, electricidad y fontanería'
    },
    {
      title: 'Instalación Eléctrica Comercial',
      category: 'Comercial',
      image: 'https://storage.readdy-site.link/project_files/d728b9a4-e447-424f-b9b5-cf16bdf95d7c/e3e76af2-b5bf-4b11-87d1-0c2c7a24f9b6_IMG-20260322-WA0001.jpg?v=c2dfe2a730c3544dc55101bb2c04ccda',
      description: 'Sistema eléctrico completo para local comercial en Arrecife'
    },
    {
      title: 'Impermeabilización Terraza',
      category: 'Impermeabilización',
      image: 'https://readdy.ai/api/search-image?query=waterproofed%20rooftop%20terrace%20with%20protective%20coating%20showing%20professional%20waterproofing%20work%20with%20clean%20surface%20and%20drainage%20system%20in%20sunny%20Lanzarote%20weather%20with%20ocean%20view%20in%20background&width=800&height=600&seq=project-terrace-waterproof&orientation=landscape',
      description: 'Protección total contra filtraciones en terraza de 120m²'
    },
    {
      title: 'Tabiquería Pladur Oficina',
      category: 'Pladur',
      image: 'https://readdy.ai/api/search-image?query=modern%20office%20interior%20with%20drywall%20partitions%20showing%20clean%20white%20walls%20and%20professional%20finish%20with%20contemporary%20design%20and%20good%20lighting%20demonstrating%20quality%20construction%20work&width=800&height=600&seq=project-office-drywall&orientation=landscape',
      description: 'Distribución de espacios con pladur y aislamiento acústico'
    },
    {
      title: 'Pintura Exterior Edificio',
      category: 'Pintura',
      image: 'https://readdy.ai/api/search-image?query=freshly%20painted%20building%20exterior%20facade%20with%20smooth%20finish%20and%20vibrant%20colors%20showing%20professional%20painting%20work%20with%20scaffolding%20and%20clean%20results%20in%20sunny%20weather%20demonstrating%20quality%20craftsmanship&width=800&height=600&seq=project-building-paint&orientation=landscape',
      description: 'Pintura de fachada con preparación y acabado profesional'
    },
    {
      title: 'Renovación Baño Completo',
      category: 'Fontanería',
      image: 'https://readdy.ai/api/search-image?query=modern%20renovated%20bathroom%20with%20new%20plumbing%20fixtures%20contemporary%20tiles%20and%20clean%20design%20showing%20quality%20installation%20work%20with%20proper%20lighting%20and%20professional%20finish%20in%20bright%20clean%20space&width=800&height=600&seq=project-bathroom-renovation&orientation=landscape',
      description: 'Instalación completa de fontanería, azulejos y acabados'
    }
  ];

  return (
    <section id="proyectos" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Proyectos <strong className="text-amber-500">Realizados</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Algunos de nuestros trabajos de <strong>construcción y reformas en Lanzarote</strong> que demuestran nuestra calidad y profesionalismo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              onClick={() => {
                const el = document.getElementById('contacto');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer group"
            >
              <div className="relative h-72 overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                <div className="absolute top-4 right-4">
                  <span className="bg-amber-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                    {project.category}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-xl font-bold text-white mb-1">{project.title}</h3>
                  <p className="text-sm text-gray-200">{project.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-amber-500 to-amber-600 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">¿Tienes un proyecto en mente?</h3>
          <p className="text-lg mb-6 max-w-2xl mx-auto">
            Cuéntanos tu idea y te ayudaremos a hacerla realidad con nuestros servicios de <strong>construcción en Lanzarote</strong>
          </p>
          <button onClick={() => {
            const element = document.getElementById('contacto');
            if (element) element.scrollIntoView({ behavior: 'smooth' });
          }} className="bg-white text-amber-600 px-8 py-3 rounded-lg text-base font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
            Solicitar Presupuesto Gratis
          </button>
        </div>
      </div>
    </section>
  );
}
